export enum PaymentLinkErrors {
  SOMETHING_WENT_WRONG = '10000',
  PAYMENT_LINK_NOT_FOUND = '10024',
  PAYMENT_LINK_HAS_NO_ITEMS = '10026',
  PAYMENT_LINK_INVALID = '10025',
  PAYMENT_LINK_DELETED = '10029',
  PAYMENT_LINK_STATUS_PAID = '10004',
  PAYMENT_LINK_STATUS_INVALID = '10005',
  PAYMENT_LINK_PARTNER_INVALID = '10006',
  PAYMENT_LINK_EXPIRED = '10007',
  PAYMENT_LINK_CANCELLED = '10008',
  PAYMENT_LINK_AMOUNT_INVALID = '10009',
  PAYMENT_LINK_AMOUNT_MISMATCH = '10011',
}

export const PAYMENT_LINK_NOT_FOUND = [
  PaymentLinkErrors.PAYMENT_LINK_NOT_FOUND,
  PaymentLinkErrors.PAYMENT_LINK_INVALID,
  PaymentLinkErrors.PAYMENT_LINK_CANCELLED,
];

export default PaymentLinkErrors;
